import { onMounted, reactive, toRefs, watch } from "vue";
import apis from "@/api";
export default {
  name: "SensitiveWords",
  props: {
    sensWordsList: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  setup(props, ctx) {
    const data = reactive({});
    return {
      ...toRefs(data)
    };
  }
};